// extracted by mini-css-extract-plugin
module.exports = {"simpleHeaderContainer":"simple-header_simpleHeaderContainer__9HFg0","navWrapper":"simple-header_navWrapper__nZZBD","skipNav":"simple-header_skipNav__sKxZl"};